import { FileText } from "lucide-react";

export default function Termos() {
  return (
    <div className="min-h-screen bg-[#050B14] text-slate-100">
      <div className="max-w-3xl mx-auto px-6 py-24">
        <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-white/10 bg-white/[0.04] text-[11px] font-semibold uppercase tracking-[0.2em] text-blue-300 mb-8">
          <FileText className="h-3.5 w-3.5" />
          Termos de Serviço
        </div>

        <h1 className="text-4xl sm:text-5xl font-semibold tracking-tighter text-white leading-[1.05] mb-4">
          Termos e Condições
        </h1>
        <p className="text-slate-400 text-lg mb-12">Última actualização: Maio de 2026</p>

        <div className="space-y-10 text-slate-300 leading-relaxed">

          <Section title="Aceitação dos Termos">
            <p>Ao contratar ou utilizar os serviços da Automia, o cliente aceita integralmente os presentes Termos e Condições. Caso não concorde, deverá cessar a utilização do serviço.</p>
          </Section>

          <Section title="Descrição do Serviço">
            <p>A Automia é uma plataforma de automação de atendimento e marcações via WhatsApp, com integração ao Google Calendar. O serviço inclui um assistente de IA configurado para o negócio do cliente, disponível 24 horas por dia.</p>
          </Section>

          <Section title="Período de Teste">
            <p>A Automia oferece um período de teste de 7 dias gratuitos, sem necessidade de cartão de crédito. Findo este período, o serviço será suspenso salvo subscrição de um plano pago.</p>
          </Section>

          <Section title="Obrigações do Cliente">
            <ul className="list-disc list-inside space-y-1 text-slate-400">
              <li>Fornecer informação correcta e actualizada sobre o negócio</li>
              <li>Não utilizar o serviço para fins ilegais ou que violem direitos de terceiros</li>
              <li>Manter confidenciais as credenciais de acesso</li>
              <li>Cumprir com as obrigações legais aplicáveis ao tratamento de dados dos seus clientes</li>
            </ul>
          </Section>

          <Section title="Limitação de Responsabilidade">
            <p>A Automia não se responsabiliza por perdas indirectas resultantes de falhas técnicas fora do seu controlo, erros de configuração fornecidos pelo cliente, ou interrupções de serviços de terceiros (WhatsApp, Google Calendar).</p>
          </Section>

          <Section title="Propriedade Intelectual">
            <p>Toda a tecnologia, código e marca da Automia são propriedade exclusiva da empresa. O cliente não adquire qualquer direito de propriedade intelectual sobre o serviço.</p>
          </Section>

          <Section title="Cancelamento">
            <p>O cliente pode cancelar o serviço a qualquer momento, sem penalização. O cancelamento é efectuado por e-mail para <a href="mailto:ola@automia.pt" className="text-blue-400 hover:text-blue-300">ola@automia.pt</a>. Não são emitidos reembolsos por períodos já facturados.</p>
          </Section>

          <Section title="Alterações aos Termos">
            <p>A Automia reserva-se o direito de alterar estes Termos com aviso prévio de 15 dias por e-mail. A continuação do uso do serviço após esse prazo implica a aceitação das alterações.</p>
          </Section>

          <Section title="Lei Aplicável">
            <p>Os presentes Termos são regidos pela lei portuguesa. Qualquer litígio será submetido aos tribunais competentes de Portugal.</p>
          </Section>

          <Section title="Contacto">
            <p>Para questões sobre estes Termos: <a href="mailto:ola@automia.pt" className="text-blue-400 hover:text-blue-300">ola@automia.pt</a></p>
          </Section>

        </div>

        <div className="mt-16 pt-8 border-t border-white/10">
          <a href="/" className="text-sm text-slate-400 hover:text-white transition-colors">← Voltar ao início</a>
        </div>
      </div>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div>
      <h2 className="text-xl font-medium text-white mb-3">{title}</h2>
      {children}
    </div>
  );
}
